import { render, staticRenderFns } from "./f4.vue?vue&type=template&id=79f567bf&scoped=true&"
import script from "./f4.vue?vue&type=script&lang=js&"
export * from "./f4.vue?vue&type=script&lang=js&"
import style0 from "./f4.vue?vue&type=style&index=0&id=79f567bf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f567bf",
  null
  
)

component.options.__file = "f4.vue"
export default component.exports